export default "__VITE_ASSET__B$Ss$mVe__"